export default {
    logout() {
        const sessionId = localStorage.getItem("session_id");
        const cartCount = localStorage.getItem("cartCount");
        localStorage.clear();
        if (sessionId) localStorage.setItem("session_id", sessionId);
        if (cartCount) localStorage.setItem("cartCount", cartCount);
        window.location.href = "/";
    },
    validateMobileNo(mobileNo) {
        let prefixEntered = mobileNo.substring(0, 3);
        const validPrefix = [
            "011",
            "012",
            "013",
            "014",
            "015",
            "016",
            "017",
            "018",
            "019"
        ];
        let status = validPrefix.includes(prefixEntered);
        if (!status || mobileNo.length !== 11) {
            return false;
        } else {
            return true;
        }
    },
    UrlGenerate(query, ids){
		var url = new URL(window.location.href);
		var search_params = url.searchParams;
		// new value of "id" is set to "101"
		search_params.set(query, ids);
		// change the search property of the main url
		url.search = search_params.toString();
		// the new url string
		var new_url = url.toString();
		// output : http://demourl.com/path?id=101&topic=main
		//console.log(new_url);
        return new_url;
		//window.location.href = new_url;
	},    
    removeURLParameter(parameter){
        let url = window.location.href;
        //prefer to use l.search if you have a location/link object
        var urlparts= url.split('?');   
        if (urlparts.length>=2) {

            var prefix= encodeURIComponent(parameter)+'=';
            var pars= urlparts[1].split(/[&;]/g);

            //reverse iteration as may be destructive
            for (var i= pars.length; i-- > 0;) {    
                //idiom for string.startsWith
                if (pars[i].lastIndexOf(prefix, 0) !== -1) {  
                    pars.splice(i, 1);
                }
            }

            url= urlparts[0]+'?'+pars.join('&');
            return url;
        } else {
            return url;
        }
	},
    goTo(whereTo) {
        if(whereTo){
            window.location.href = '/'+whereTo;
        }
    },    
    cartCount() {
        return parseInt(localStorage.getItem("cartCount") || "0");
    },
    cartAmount() {
        return parseFloat(localStorage.getItem("cartAmount") || "0").toFixed(2);
    },
    engNTbn(engNumber) {
        if(engNumber){
            var numbers = {
                '0': '০',
                '1': '১',
                '2': '২',
                '3': '৩',
                '4': '৪',
                '5': '৫',
                '6': '৬',
                '7': '৭',
                '8': '৮',
                '9': '৯'
            };
    
            var output = [];
            for (var i = 0; i < engNumber.length; ++i) {
                if (numbers.hasOwnProperty(engNumber[i])) {
                    output.push(numbers[engNumber[i]]);
                } else {
                    output.push(engNumber[i]);
                }
            }
            return output.join('');
        }
    },

    /**
     * Stores recently viewed urls to local storage along with their view times
     *
     * @param {String} key - the localStorage key where the list is stored
     * @param {String} url - the location of the page that was viewed
     * @param {Object} json - arbitrary json blob associated with a url
     * @param {Integer} limit - the max number of urls to save
     */
    
    addToRecentlyViewed (key, url, json, limit) {

    var viewedAt = Date.now(),
      recentlyViewed = localStorage[key],
      alreadyInRecents = false,
      limit = (limit) ? limit : 20;
  
    // initialize the local storage recent views if it hasn't been
  
    try {
      recentlyViewed = (recentlyViewed) ? JSON.parse(recentlyViewed) : [];
    } catch(e) {
      console.log('Error parsing json of recently viewed items');
      recentlyViewed = [];
    }
  
    // if the url is already in the set, update the view time and the data
  
    for (var i=0; i < recentlyViewed.length && !alreadyInRecents; i++) {
      if (recentlyViewed[i]["url"] && recentlyViewed[i]["url"] === url) {
        recentlyViewed[i]["viewedAt"] = viewedAt;
        recentlyViewed[i]["json"] = json;
        alreadyInRecents = true;
      }
    }
  
    // add the url to the recently viewed list if it wasn't updated in place
  
    if (!alreadyInRecents) {
      recentlyViewed.unshift({ url: url, viewedAt: viewedAt, json: json });
    }
  
    // sort urls by recently viewed times descending
  
    recentlyViewed.sort( function(a,b) {
      if ( a.viewedAt > b.viewedAt ) return -1;
      if ( a.viewedAt < b.viewedAt ) return 1;
      return 0;
    });
  
    // save a limited list of recently viewed items to local storage
  
    localStorage[key] = JSON.stringify( recentlyViewed.slice(0, limit) );
  }
};